import { useCallback } from 'react';

import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import { FormattedMessage } from '@zenbusiness/application-commons-intl';

import { ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES } from '#client/constants/experimentsFlags';

import * as Styled from './CookiePreferences.style';

function CookiePreferences() {
  const enableDashboardLinkToManageCookies = useExperimentFlag(ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES, false);

  const isCookiePreferencesAvailable = typeof window !== 'undefined' && Boolean(window.Osano?.cm?.showDrawer);
  const showCookiePreferences = isCookiePreferencesAvailable && enableDashboardLinkToManageCookies;

  const handleCookiePreferencesClick = useCallback(() => {
    // Safely access Osano cookie manager
    window.Osano.cm.showDrawer('osano-cm-dom-info-dialog-open');
  }, []);

  if (!showCookiePreferences) {
    return null;
  }

  return (
    <Styled.StyledButtonBase
      clickstreamProps={{
        elementName: 'cookie_preferences',
      }}
      onClick={handleCookiePreferencesClick}
    >
      <FormattedMessage id="dashboard.footer.cookiePreferences.label" />
    </Styled.StyledButtonBase>
  );
}

export default CookiePreferences;
